import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, Upload, Dumbbell, Trophy, Mic, FileText, Users, 
  Bell, Settings, LogOut, Menu, X, ChevronRight, Eye, 
  Video, Image as ImageIcon, FolderOpen, Utensils, Mail, BarChart3,
  UserPlus, Trash2, Edit, RefreshCw, Percent, Tag, DollarSign, Lock, Package, Shield,
  Star, MessageSquare, CheckCircle, Download, Crown, Sparkles, ClipboardList
} from 'lucide-react';
import { Button } from '../components/ui/button';
import axios from 'axios';
import { toast } from 'sonner';

// Importar componentes de administración
import AdminChallenges from './AdminChallenges';
import AdminPodcasts from './AdminPodcasts';
import AdminBlog from './AdminBlog';
import AdminContent from './AdminContent';
import AdminProgramContent from './AdminProgramContent';
import AdminSiteConfig from './AdminSiteConfig';
import AdminContentManager from './AdminContentManager';
import AdminPrograms from './AdminPrograms';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Componente de estadísticas del dashboard
const DashboardStats = ({ stats }) => (
  <div className="space-y-6">
    <div>
      <h2 className="text-2xl font-bold mb-6 text-white">Panel de Control</h2>
      
      {/* Stats Grid - Principales */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-4">
          <div className="flex flex-col items-center text-center">
            <div className="w-10 h-10 bg-pink-500/20 rounded-xl flex items-center justify-center mb-2">
              <Users className="w-5 h-5 text-pink-500" />
            </div>
            <p className="text-2xl font-bold text-white">{stats.total_users || 0}</p>
            <p className="text-xs text-zinc-500">Usuarios</p>
          </div>
        </div>
        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-4">
          <div className="flex flex-col items-center text-center">
            <div className="w-10 h-10 bg-green-500/20 rounded-xl flex items-center justify-center mb-2">
              <Video className="w-5 h-5 text-green-500" />
            </div>
            <p className="text-2xl font-bold text-white">{stats.total_videos || 0}</p>
            <p className="text-xs text-zinc-500">Videos</p>
          </div>
        </div>
        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-4">
          <div className="flex flex-col items-center text-center">
            <div className="w-10 h-10 bg-blue-500/20 rounded-xl flex items-center justify-center mb-2">
              <Trophy className="w-5 h-5 text-blue-500" />
            </div>
            <p className="text-2xl font-bold text-white">{stats.total_challenges || 0}</p>
            <p className="text-xs text-zinc-500">Challenges</p>
          </div>
        </div>
        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-4">
          <div className="flex flex-col items-center text-center">
            <div className="w-10 h-10 bg-orange-500/20 rounded-xl flex items-center justify-center mb-2">
              <FileText className="w-5 h-5 text-orange-500" />
            </div>
            <p className="text-2xl font-bold text-white">{stats.total_blog || 0}</p>
            <p className="text-xs text-zinc-500">Blogs</p>
          </div>
        </div>
        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-4">
          <div className="flex flex-col items-center text-center">
            <div className="w-10 h-10 bg-red-500/20 rounded-xl flex items-center justify-center mb-2">
              <ImageIcon className="w-5 h-5 text-red-500" />
            </div>
            <p className="text-2xl font-bold text-white">{stats.total_ebooks || 0}</p>
            <p className="text-xs text-zinc-500">Ebooks</p>
          </div>
        </div>
        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-4">
          <div className="flex flex-col items-center text-center">
            <div className="w-10 h-10 bg-purple-500/20 rounded-xl flex items-center justify-center mb-2">
              <BarChart3 className="w-5 h-5 text-purple-500" />
            </div>
            <p className="text-2xl font-bold text-green-400">${stats.total_revenue || 0}</p>
            <p className="text-xs text-zinc-500">Ingresos</p>
          </div>
        </div>
      </div>

      {/* Stats Grid - Secundarios */}
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 mb-8">
        <div className="bg-zinc-800/50 border border-zinc-700/50 rounded-xl p-3 text-center">
          <p className="text-lg font-bold text-purple-400">{stats.total_mindset || 0}</p>
          <p className="text-xs text-zinc-500">Mindset</p>
        </div>
        <div className="bg-zinc-800/50 border border-zinc-700/50 rounded-xl p-3 text-center">
          <p className="text-lg font-bold text-yellow-400">{stats.total_academia || 0}</p>
          <p className="text-xs text-zinc-500">Academia</p>
        </div>
        <div className="bg-zinc-800/50 border border-zinc-700/50 rounded-xl p-3 text-center">
          <p className="text-lg font-bold text-cyan-400">{stats.total_recetas || 0}</p>
          <p className="text-xs text-zinc-500">Recetas</p>
        </div>
        <div className="bg-zinc-800/50 border border-zinc-700/50 rounded-xl p-3 text-center">
          <p className="text-lg font-bold text-pink-400">{stats.total_rutinas || 0}</p>
          <p className="text-xs text-zinc-500">Rutinas</p>
        </div>
        <div className="bg-zinc-800/50 border border-zinc-700/50 rounded-xl p-3 text-center">
          <p className="text-lg font-bold text-indigo-400">{stats.total_pdfs || 0}</p>
          <p className="text-xs text-zinc-500">PDFs</p>
        </div>
        <div className="bg-zinc-800/50 border border-zinc-700/50 rounded-xl p-3 text-center">
          <p className="text-lg font-bold text-emerald-400">{stats.total_nutrition_plans || 0}</p>
          <p className="text-xs text-zinc-500">Planes Nutri</p>
        </div>
        <div className="bg-zinc-800/50 border border-zinc-700/50 rounded-xl p-3 text-center">
          <p className="text-lg font-bold text-blue-400">{stats.paid_transactions || 0}</p>
          <p className="text-xs text-zinc-500">Ventas</p>
        </div>
        <div className="bg-zinc-800/50 border border-zinc-700/50 rounded-xl p-3 text-center">
          <p className="text-lg font-bold text-zinc-400">{stats.total_content || 0}</p>
          <p className="text-xs text-zinc-500">Total Contenido</p>
        </div>
      </div>

      {/* Usuarios por Nivel */}
      {stats.users_by_level && (
        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-5 mb-8">
          <h4 className="font-bold mb-4 text-sm text-white">Usuarios por Nivel de Suscripción</h4>
          <div className="flex flex-wrap gap-4">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-zinc-400"></div>
              <span className="text-sm text-zinc-300">Gratis: <strong className="text-white">{stats.users_by_level.free || 0}</strong></span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-green-500"></div>
              <span className="text-sm text-zinc-300">Nivel 1: <strong className="text-white">{stats.users_by_level.nivel_1 || 0}</strong></span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-blue-500"></div>
              <span className="text-sm text-zinc-300">Nivel 2: <strong className="text-white">{stats.users_by_level.nivel_2 || 0}</strong></span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-pink-500"></div>
              <span className="text-sm text-zinc-300">Premium: <strong className="text-white">{stats.users_by_level.premium || 0}</strong></span>
            </div>
          </div>
        </div>
      )}

      {/* Quick Actions */}
      <h3 className="text-lg font-bold mb-4 text-white">Acciones Rápidas</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <QuickActionCard 
          icon={<FolderOpen className="w-8 h-8" />}
          title="Gestor de Contenido"
          description="Videos, Ebooks, Challenges, Blog, Podcasts"
          color="pink"
          section="content-manager"
        />
        <QuickActionCard 
          icon={<Users className="w-8 h-8" />}
          title="Gestionar Usuarios"
          description="Ver y administrar clientes"
          color="blue"
          link="/admin/clients"
        />
        <QuickActionCard 
          icon={<Bell className="w-8 h-8" />}
          title="Enviar Notificación"
          description="Email masivo a usuarios"
          color="red"
          section="notifications"
        />
        <QuickActionCard 
          icon={<Settings className="w-8 h-8" />}
          title="Configuración del Sitio"
          description="Imágenes, textos y diseño"
          color="purple"
          section="site-config"
        />
        <QuickActionCard 
          icon={<UserPlus className="w-8 h-8" />}
          title="Cuentas de Prueba"
          description="Crear usuarios de prueba"
          color="green"
          section="test-accounts"
        />
        <QuickActionCard 
          icon={<Utensils className="w-8 h-8" />}
          title="Planes Nutricionales"
          description="Ver planes de usuarios"
          color="orange"
          section="nutrition-forms"
        />
      </div>
    </div>
  </div>
);

// Card de acción rápida
const QuickActionCard = ({ icon, title, description, color, section, link }) => {
  const colors = {
    pink: 'bg-pink-500/10 text-pink-400 border-pink-500/30 hover:bg-pink-500/20',
    green: 'bg-green-500/10 text-green-400 border-green-500/30 hover:bg-green-500/20',
    blue: 'bg-blue-500/10 text-blue-400 border-blue-500/30 hover:bg-blue-500/20',
    purple: 'bg-purple-500/10 text-purple-400 border-purple-500/30 hover:bg-purple-500/20',
    orange: 'bg-orange-500/10 text-orange-400 border-orange-500/30 hover:bg-orange-500/20',
    red: 'bg-red-500/10 text-red-400 border-red-500/30 hover:bg-red-500/20',
  };

  const handleClick = () => {
    if (link) {
      window.location.href = link;
    } else if (section) {
      window.dispatchEvent(new CustomEvent('admin-navigate', { detail: section }));
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`p-5 rounded-2xl text-left transition-all border ${colors[color]} w-full`}
    >
      <div className="mb-3">{icon}</div>
      <h4 className="font-bold text-white">{title}</h4>
      <p className="text-sm text-zinc-400">{description}</p>
    </button>
  );
};

// Componente de notificaciones
const NotificationsPanel = () => {
  const [sending, setSending] = useState(false);
  const [testingEmail, setTestingEmail] = useState(false);
  const [notificationForm, setNotificationForm] = useState({
    subject: '',
    message: '',
    target_level: 'all',
    image_url: ''
  });
  const [contentNotifForm, setContentNotifForm] = useState({
    content_title: '',
    content_type: 'Video',
    target_level: 'all'
  });
  const [testEmail, setTestEmail] = useState('');
  const [notifications, setNotifications] = useState([]);
  const [activeTab, setActiveTab] = useState('general');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [emojiTarget, setEmojiTarget] = useState('subject'); // 'subject' o 'message'
  const token = localStorage.getItem('session_token');

  // Lista de emojis populares
  const popularEmojis = [
    '🎉', '💪', '🔥', '⭐', '💕', '✨', '🏆', '💯', '🚀', '👏',
    '💖', '🌟', '😍', '🥳', '💃', '🎯', '❤️', '💫', '🙌', '👑',
    '🍑', '🏋️', '🥗', '💪🏼', '🧘', '🏃‍♀️', '🥑', '🍎', '💧', '☀️',
    '📢', '📣', '🆕', '⚡', '🎁', '💌', '📩', '✅', '🔔', '📌'
  ];

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/admin/notifications-log`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setNotifications(response.data || []);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  const insertEmoji = (emoji) => {
    if (emojiTarget === 'subject') {
      setNotificationForm({...notificationForm, subject: notificationForm.subject + emoji});
    } else {
      setNotificationForm({...notificationForm, message: notificationForm.message + emoji});
    }
  };

  const sendGeneralNotification = async () => {
    if (!notificationForm.subject || !notificationForm.message) {
      toast.error('Ingresa asunto y mensaje');
      return;
    }

    setSending(true);
    try {
      const response = await axios.post(`${BACKEND_URL}/api/admin/send-notification`, notificationForm, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success(response.data.message);
      setNotificationForm({ subject: '', message: '', target_level: 'all', image_url: '' });
      fetchNotifications();
    } catch (error) {
      toast.error('Error al enviar notificación');
    } finally {
      setSending(false);
    }
  };

  const sendContentNotification = async () => {
    if (!contentNotifForm.content_title) {
      toast.error('Ingresa el título del contenido');
      return;
    }

    setSending(true);
    try {
      const response = await axios.post(`${BACKEND_URL}/api/admin/send-content-notification`, contentNotifForm, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success(response.data.message);
      setContentNotifForm({ content_title: '', content_type: 'Video', target_level: 'all' });
      fetchNotifications();
    } catch (error) {
      toast.error('Error al enviar notificación');
    } finally {
      setSending(false);
    }
  };

  const sendTestEmail = async () => {
    if (!testEmail) {
      toast.error('Ingresa un email para la prueba');
      return;
    }

    setTestingEmail(true);
    try {
      const response = await axios.post(`${BACKEND_URL}/api/admin/test-email`, { email: testEmail }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success(response.data.message);
    } catch (error) {
      toast.error('Error al enviar email de prueba');
    } finally {
      setTestingEmail(false);
    }
  };

  const targetLevelOptions = [
    { value: 'all', label: '📢 Todos los usuarios' },
    { value: 'free', label: '🆓 Solo usuarios gratis' },
    { value: 'principiante', label: '🟢 Nivel 1 - Principiante' },
    { value: 'intermedio', label: '🟡 Nivel 2 - Intermedio' },
    { value: 'premium', label: '⭐ Premium' },
  ];

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold flex items-center gap-2">
        <Mail className="w-6 h-6 text-pink-500" />
        Centro de Notificaciones por Email
      </h2>

      {/* Tabs */}
      <div className="flex gap-2 bg-zinc-900 rounded-2xl p-2 border border-zinc-800">
        <button
          onClick={() => setActiveTab('general')}
          className={`flex-1 py-3 px-4 rounded-xl font-medium transition-all ${
            activeTab === 'general' ? 'bg-pink-500 text-white' : 'hover:bg-zinc-800'
          }`}
        >
          📧 Mensaje General
        </button>
        <button
          onClick={() => setActiveTab('content')}
          className={`flex-1 py-3 px-4 rounded-xl font-medium transition-all ${
            activeTab === 'content' ? 'bg-pink-500 text-white' : 'hover:bg-zinc-800'
          }`}
        >
          🆕 Nuevo Contenido
        </button>
        <button
          onClick={() => setActiveTab('test')}
          className={`flex-1 py-3 px-4 rounded-xl font-medium transition-all ${
            activeTab === 'test' ? 'bg-pink-500 text-white' : 'hover:bg-zinc-800'
          }`}
        >
          🧪 Email de Prueba
        </button>
      </div>

      {/* Tab: Mensaje General */}
      {activeTab === 'general' && (
        <div className="bg-zinc-900 rounded-2xl p-6 border border-zinc-800 space-y-4">
          <h3 className="font-bold text-lg">Enviar Mensaje Personalizado</h3>
          
          {/* Selector de Emojis */}
          <div className="relative">
            <button
              onClick={() => setShowEmojiPicker(!showEmojiPicker)}
              className="flex items-center gap-2 px-4 py-2 bg-zinc-800 hover:bg-zinc-700 text-white rounded-xl transition-colors border border-zinc-700"
            >
              😊 Insertar Emoji
            </button>
            
            {showEmojiPicker && (
              <div className="absolute top-12 left-0 bg-zinc-900 border border-zinc-700 rounded-2xl shadow-lg p-4 z-10 w-80">
                <div className="flex gap-2 mb-3">
                  <button
                    onClick={() => setEmojiTarget('subject')}
                    className={`flex-1 py-2 rounded-lg text-sm font-medium ${
                      emojiTarget === 'subject' ? 'bg-pink-500 text-white' : 'bg-zinc-800 text-zinc-300 border border-zinc-700'
                    }`}
                  >
                    En Asunto
                  </button>
                  <button
                    onClick={() => setEmojiTarget('message')}
                    className={`flex-1 py-2 rounded-lg text-sm font-medium ${
                      emojiTarget === 'message' ? 'bg-pink-500 text-white' : 'bg-zinc-800 text-zinc-300 border border-zinc-700'
                    }`}
                  >
                    En Mensaje
                  </button>
                </div>
                <div className="grid grid-cols-10 gap-1">
                  {popularEmojis.map((emoji, idx) => (
                    <button
                      key={idx}
                      onClick={() => insertEmoji(emoji)}
                      className="text-xl hover:bg-zinc-800 rounded p-1 transition-colors"
                    >
                      {emoji}
                    </button>
                  ))}
                </div>
                <button
                  onClick={() => setShowEmojiPicker(false)}
                  className="w-full mt-3 py-2 bg-zinc-800 text-zinc-300 rounded-lg text-sm hover:bg-zinc-700 border border-zinc-700"
                >
                  Cerrar
                </button>
              </div>
            )}
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-2">Asunto del Email</label>
            <input
              value={notificationForm.subject}
              onChange={(e) => setNotificationForm({...notificationForm, subject: e.target.value})}
              placeholder="Ej: 🎉 ¡Novedades importantes en Booty&Legs!"
              className="w-full px-4 py-3 border border-zinc-700 rounded-xl bg-zinc-800 text-white"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-2">Mensaje</label>
            <textarea
              value={notificationForm.message}
              onChange={(e) => setNotificationForm({...notificationForm, message: e.target.value})}
              placeholder="Escribe tu mensaje aquí... Puedes usar saltos de línea para dar formato."
              rows={6}
              className="w-full px-4 py-3 border border-zinc-700 rounded-xl resize-none bg-zinc-800 text-white placeholder-zinc-500"
            />
          </div>
          
          {/* Imagen adjunta */}
          <div>
            <label className="block text-sm font-medium mb-2">🖼️ Imagen (opcional)</label>
            <input
              value={notificationForm.image_url}
              onChange={(e) => setNotificationForm({...notificationForm, image_url: e.target.value})}
              placeholder="URL de la imagen (ej: https://tu-imagen.com/foto.jpg)"
              className="w-full px-4 py-3 border border-zinc-700 rounded-xl bg-zinc-800 text-white"
            />
            <p className="text-xs text-zinc-500 mt-1">
              Pega el enlace directo de una imagen. Puedes subir imágenes a servicios como Imgur o usar URLs públicas.
            </p>
            {notificationForm.image_url && (
              <div className="mt-2 p-2 bg-zinc-800 rounded-xl">
                <p className="text-xs text-zinc-500 mb-2">Vista previa:</p>
                <img 
                  src={notificationForm.image_url} 
                  alt="Preview" 
                  className="max-h-32 rounded-lg mx-auto"
                  onError={(e) => e.target.style.display = 'none'}
                />
              </div>
            )}
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-2">Enviar a</label>
            <select
              value={notificationForm.target_level}
              onChange={(e) => setNotificationForm({...notificationForm, target_level: e.target.value})}
              className="w-full px-4 py-3 border border-zinc-700 rounded-xl bg-zinc-800 text-white"
            >
              {targetLevelOptions.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>

          <div className="bg-yellow-900/30 border border-yellow-700 rounded-xl p-4">
            <p className="text-sm text-yellow-400">
              ⚠️ <strong>Importante:</strong> Los emails incluyen automáticamente un mensaje para que los usuarios 
              muevan el correo fuera de spam y lo agreguen a contactos de confianza.
            </p>
          </div>

          <Button
            onClick={sendGeneralNotification}
            disabled={sending}
            className="w-full bg-pink-600 hover:bg-pink-700 text-white rounded-full py-4"
          >
            {sending ? 'Enviando...' : '📤 Enviar Notificación Masiva'}
          </Button>
        </div>
      )}

      {/* Tab: Nuevo Contenido */}
      {activeTab === 'content' && (
        <div className="bg-zinc-900 rounded-2xl p-6 border border-zinc-800 space-y-4">
          <h3 className="font-bold text-lg">Notificar Nuevo Contenido</h3>
          
          <div>
            <label className="block text-sm font-medium mb-2">Título del contenido</label>
            <input
              value={contentNotifForm.content_title}
              onChange={(e) => setContentNotifForm({...contentNotifForm, content_title: e.target.value})}
              placeholder="Ej: Nueva rutina de glúteos - Día 5"
              className="w-full px-4 py-3 border border-zinc-700 rounded-xl bg-zinc-800 text-white"
            />
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2">Tipo de contenido</label>
              <select
                value={contentNotifForm.content_type}
                onChange={(e) => setContentNotifForm({...contentNotifForm, content_type: e.target.value})}
                className="w-full px-4 py-3 border border-zinc-700 rounded-xl bg-zinc-800 text-white"
              >
                <option value="Video">🎬 Video</option>
                <option value="PDF/Ebook">📚 PDF/Ebook</option>
                <option value="Receta">🍳 Receta</option>
                <option value="Challenge">🏆 Challenge</option>
                <option value="Artículo">📝 Artículo</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">Enviar a</label>
              <select
                value={contentNotifForm.target_level}
                onChange={(e) => setContentNotifForm({...contentNotifForm, target_level: e.target.value})}
                className="w-full px-4 py-3 border border-zinc-700 rounded-xl bg-zinc-800 text-white"
              >
                {targetLevelOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="bg-pink-900/30 border border-pink-700 rounded-xl p-4">
            <h4 className="font-medium text-pink-400 mb-2">Vista previa:</h4>
            <p className="text-sm text-pink-300">
              ¡Nuevo contenido disponible: <strong>{contentNotifForm.content_title || '[Título]'}</strong>! 
              Tipo: {contentNotifForm.content_type}
            </p>
          </div>

          <Button
            onClick={sendContentNotification}
            disabled={sending}
            className="w-full bg-pink-600 hover:bg-pink-700 text-white rounded-full py-4"
          >
            {sending ? 'Enviando...' : '📤 Notificar Nuevo Contenido'}
          </Button>
        </div>
      )}

      {/* Tab: Email de Prueba */}
      {activeTab === 'test' && (
        <div className="bg-zinc-900 rounded-2xl p-6 border border-zinc-800 space-y-4">
          <h3 className="font-bold text-lg">Enviar Email de Prueba</h3>
          <p className="text-zinc-500">Verifica que el servicio de email esté funcionando correctamente.</p>
          
          <div>
            <label className="block text-sm font-medium mb-2">Email de destino</label>
            <input
              type="email"
              value={testEmail}
              onChange={(e) => setTestEmail(e.target.value)}
              placeholder="tu@email.com"
              className="w-full px-4 py-3 border border-zinc-700 rounded-xl bg-zinc-800 text-white"
            />
          </div>

          <Button
            onClick={sendTestEmail}
            disabled={testingEmail}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-full py-4"
          >
            {testingEmail ? 'Enviando...' : '🧪 Enviar Email de Prueba'}
          </Button>
        </div>
      )}

      {/* Historial */}
      <div className="bg-zinc-900 rounded-2xl p-6 border border-zinc-800">
        <h3 className="font-bold mb-4">📋 Historial de Notificaciones</h3>
        {notifications.length === 0 ? (
          <p className="text-zinc-500 text-center py-4">No hay notificaciones enviadas</p>
        ) : (
          <div className="space-y-3 max-h-96 overflow-y-auto">
            {notifications.slice(0, 20).map((notif, idx) => (
              <div key={idx} className="flex items-center justify-between p-3 bg-zinc-800 rounded-xl">
                <div className="flex-1">
                  <p className="font-medium">{notif.subject || notif.content_title}</p>
                  <p className="text-sm text-zinc-500">
                    {new Date(notif.created_at || notif.sent_at).toLocaleDateString('es-ES', {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })} 
                    {' • '}{notif.sent_count || notif.recipients_count} destinatarios
                  </p>
                </div>
                <span className="px-3 py-1 rounded-full text-xs bg-green-100 text-green-700">
                  ✓ Enviado
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

// Componente de suscriptores newsletter
const SubscribersPanel = () => {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const token = localStorage.getItem('session_token');

  useEffect(() => {
    fetchSubscribers();
  }, []);

  const fetchSubscribers = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/admin/subscribers`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSubscribers(response.data || []);
    } catch (error) {
      console.error('Error fetching subscribers:', error);
    } finally {
      setLoading(false);
    }
  };

  const deleteSubscriber = async (subscriberId) => {
    if (!window.confirm('¿Eliminar este suscriptor?')) return;
    
    try {
      await axios.delete(`${BACKEND_URL}/api/admin/subscribers/${subscriberId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Suscriptor eliminado');
      fetchSubscribers();
    } catch (error) {
      toast.error('Error al eliminar');
    }
  };

  const exportToCSV = () => {
    const csvContent = [
      ['Email', 'Código Descuento', 'Usado', 'Fuente', 'Fecha Suscripción'].join(','),
      ...subscribers.map(s => [
        s.email,
        s.discount_code || 'N/A',
        s.discount_used ? 'Sí' : 'No',
        s.source || 'popup',
        new Date(s.subscribed_at).toLocaleDateString('es-ES')
      ].join(','))
    ].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `suscriptores_${new Date().toISOString().split('T')[0]}.csv`;
    link.click();
    toast.success('CSV exportado');
  };

  const filteredSubscribers = (subscribers || []).filter(s => 
    s.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <div className="text-center py-8">Cargando suscriptores...</div>;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold flex items-center gap-2">
          <Mail className="w-6 h-6 text-pink-500" />
          Suscriptores Newsletter
          <span className="text-sm font-normal bg-pink-900/50 text-pink-400 px-3 py-1 rounded-full ml-2">
            {(subscribers || []).length} total
          </span>
        </h2>
        <Button onClick={exportToCSV} className="bg-green-600 hover:bg-green-700 text-white rounded-full">
          📥 Exportar CSV
        </Button>
      </div>

      {/* Buscador */}
      <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Buscar por email..."
          className="w-full px-4 py-3 border border-zinc-700 rounded-xl bg-zinc-800 text-white"
        />
      </div>

      {/* Estadísticas rápidas */}
      <div className="grid grid-cols-3 gap-4">
        <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800 text-center">
          <p className="text-3xl font-bold text-pink-500">{(subscribers || []).length}</p>
          <p className="text-sm text-zinc-500">Total Suscriptores</p>
        </div>
        <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800 text-center">
          <p className="text-3xl font-bold text-green-500">
            {(subscribers || []).filter(s => s.discount_used).length}
          </p>
          <p className="text-sm text-zinc-500">Descuentos Usados</p>
        </div>
        <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800 text-center">
          <p className="text-3xl font-bold text-blue-500">
            {(subscribers || []).filter(s => !s.discount_used).length}
          </p>
          <p className="text-sm text-zinc-500">Pendientes</p>
        </div>
      </div>

      {/* Lista de suscriptores */}
      <div className="bg-zinc-900 rounded-2xl border border-zinc-800 overflow-hidden">
        <div className="max-h-[500px] overflow-y-auto">
          <table className="w-full">
            <thead className="bg-zinc-800 sticky top-0">
              <tr>
                <th className="text-left p-4 font-medium">Email</th>
                <th className="text-left p-4 font-medium">Código</th>
                <th className="text-left p-4 font-medium">Estado</th>
                <th className="text-left p-4 font-medium">Fuente</th>
                <th className="text-left p-4 font-medium">Fecha</th>
                <th className="text-center p-4 font-medium">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filteredSubscribers.length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center py-8 text-zinc-500">
                    No hay suscriptores
                  </td>
                </tr>
              ) : (
                filteredSubscribers.map(sub => (
                  <tr key={sub.subscriber_id} className="border-t hover:bg-zinc-800">
                    <td className="p-4">
                      <span className="font-medium">{sub.email}</span>
                    </td>
                    <td className="p-4">
                      <span className="bg-pink-100 text-pink-600 px-2 py-1 rounded-lg text-sm font-mono">
                        {sub.discount_code || 'N/A'}
                      </span>
                    </td>
                    <td className="p-4">
                      {sub.discount_used ? (
                        <span className="bg-green-100 text-green-600 px-2 py-1 rounded-full text-xs">
                          ✓ Usado
                        </span>
                      ) : (
                        <span className="bg-yellow-100 text-yellow-600 px-2 py-1 rounded-full text-xs">
                          Pendiente
                        </span>
                      )}
                    </td>
                    <td className="p-4 text-sm text-zinc-500">
                      {sub.source || 'popup'}
                    </td>
                    <td className="p-4 text-sm text-zinc-500">
                      {new Date(sub.subscribed_at).toLocaleDateString('es-ES', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                      })}
                    </td>
                    <td className="p-4 text-center">
                      <button
                        onClick={() => deleteSubscriber(sub.subscriber_id)}
                        className="text-red-500 hover:text-red-700 p-2"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

// Panel de Inscripciones a Challenges
const ChallengesPanel = () => {
  const navigate = useNavigate();
  const [challenges, setChallenges] = useState([]);
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedChallenge, setSelectedChallenge] = useState('all');
  const token = localStorage.getItem('session_token');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      // Obtener challenges
      const challengesRes = await axios.get(`${BACKEND_URL}/api/content?category=challenge`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setChallenges(challengesRes.data || []);

      // Obtener inscripciones
      const registrationsRes = await axios.get(`${BACKEND_URL}/api/admin/challenge-registrations`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setRegistrations(registrationsRes.data || []);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredRegistrations = selectedChallenge === 'all' 
    ? registrations 
    : registrations.filter(r => r.challenge_id === selectedChallenge);

  const exportToCSV = () => {
    const headers = ['Email', 'Nombre', 'Challenge', 'Fecha Inscripción', 'Estado'];
    const rows = filteredRegistrations.map(r => [
      r.email,
      r.name || '-',
      r.challenge_title || r.challenge_id,
      new Date(r.registered_at).toLocaleDateString('es-ES'),
      r.status || 'Activo'
    ]);
    
    const csvContent = [headers, ...rows].map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `inscripciones_challenges_${new Date().toISOString().split('T')[0]}.csv`;
    link.click();
    toast.success('CSV exportado');
  };

  const exportWhatsAppList = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/admin/export/challenge-whatsapp`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `whatsapp_challenges_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success('Lista de WhatsApp exportada');
    } catch (error) {
      toast.error('Error al exportar');
    }
  };

  const deleteRegistration = async (challengeId, registrationId, email) => {
    if (!window.confirm(`¿Eliminar la inscripción de ${email}?`)) {
      return;
    }
    
    try {
      await axios.delete(
        `${BACKEND_URL}/api/admin/challenges/${challengeId}/registrations/${registrationId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      toast.success(`Inscripción de ${email} eliminada`);
      // Recargar datos
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al eliminar inscripción');
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-pink-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold">Inscripciones a Challenges</h2>
          <p className="text-zinc-500">Base de datos de personas inscritas</p>
        </div>
        <div className="flex gap-3">
          <select
            value={selectedChallenge}
            onChange={(e) => setSelectedChallenge(e.target.value)}
            className="px-4 py-2 border border-zinc-700 rounded-xl bg-zinc-800 text-white"
          >
            <option value="all">Todos los Challenges</option>
            {challenges.map(ch => (
              <option key={ch.content_id} value={ch.content_id}>{ch.title}</option>
            ))}
          </select>
          <Button 
            onClick={() => navigate('/admin/challenges')} 
            className="bg-pink-600 hover:bg-pink-700 text-white rounded-xl"
            data-testid="manage-challenges-btn"
          >
            <Edit className="w-4 h-4 mr-2" />
            Gestionar Challenges
          </Button>
          <Button onClick={exportToCSV} variant="outline" className="rounded-xl border-zinc-700 text-zinc-300">
            📥 Exportar CSV
          </Button>
          <Button onClick={exportWhatsAppList} variant="outline" className="rounded-xl border-green-700 text-green-400 hover:bg-green-500/10">
            📱 Exportar WhatsApp
          </Button>
          <Button onClick={fetchData} variant="outline" className="rounded-xl border-zinc-700 text-zinc-300">
            <RefreshCw className="w-4 h-4" />
          </Button>
        </div>
      </div>

      {/* Estadísticas */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl p-6 text-white">
          <Trophy className="w-8 h-8 mb-2 opacity-80" />
          <p className="text-3xl font-bold">{challenges.length}</p>
          <p className="text-amber-100">Challenges Activos</p>
        </div>
        <div className="bg-gradient-to-br from-pink-500 to-rose-600 rounded-2xl p-6 text-white">
          <Users className="w-8 h-8 mb-2 opacity-80" />
          <p className="text-3xl font-bold">{registrations.length}</p>
          <p className="text-pink-100">Total Inscripciones</p>
        </div>
        <div className="bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl p-6 text-white">
          <BarChart3 className="w-8 h-8 mb-2 opacity-80" />
          <p className="text-3xl font-bold">{filteredRegistrations.length}</p>
          <p className="text-green-100">Filtradas</p>
        </div>
      </div>

      {/* Tabla de inscripciones */}
      <div className="bg-zinc-900 rounded-2xl border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-zinc-800 border-b">
              <tr>
                <th className="text-left p-4 font-medium text-zinc-400">Usuario</th>
                <th className="text-left p-4 font-medium text-zinc-400">📱 WhatsApp</th>
                <th className="text-left p-4 font-medium text-zinc-400">Challenge</th>
                <th className="text-left p-4 font-medium text-zinc-400">Fecha</th>
                <th className="text-left p-4 font-medium text-zinc-400">Estado</th>
                <th className="text-center p-4 font-medium text-zinc-400">Acciones</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {filteredRegistrations.length === 0 ? (
                <tr>
                  <td colSpan="6" className="p-8 text-center text-zinc-500">
                    <Trophy className="w-12 h-12 mx-auto mb-3 opacity-30" />
                    <p>No hay inscripciones {selectedChallenge !== 'all' && 'para este challenge'}</p>
                  </td>
                </tr>
              ) : (
                filteredRegistrations.map((reg, idx) => (
                  <tr key={idx} className="hover:bg-zinc-800">
                    <td className="p-4">
                      <div>
                        <p className="font-medium">{reg.name || 'Sin nombre'}</p>
                        <p className="text-sm text-zinc-500">{reg.email}</p>
                      </div>
                    </td>
                    <td className="p-4">
                      {reg.whatsapp || reg.phone ? (
                        <a 
                          href={`https://wa.me/${(reg.whatsapp || reg.phone).replace(/\D/g, '')}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center gap-2 bg-green-500/20 text-green-400 px-3 py-1 rounded-full text-sm hover:bg-green-500/30 transition-colors"
                        >
                          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                          </svg>
                          {reg.whatsapp || reg.phone}
                        </a>
                      ) : (
                        <span className="text-zinc-600 text-sm">Sin WhatsApp</span>
                      )}
                    </td>
                    <td className="p-4">
                      <span className="bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-sm">
                        {reg.challenge_title || reg.challenge_id}
                      </span>
                    </td>
                    <td className="p-4 text-sm text-zinc-500">
                      {new Date(reg.registered_at).toLocaleDateString('es-ES', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                      })}
                    </td>
                    <td className="p-4">
                      <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm">
                        {reg.status || 'Activo'}
                      </span>
                    </td>
                    <td className="p-4 text-center">
                      <button
                        onClick={() => deleteRegistration(reg.challenge_id, reg._id || reg.user_id, reg.email)}
                        className="p-2 text-red-400 hover:text-red-300 hover:bg-red-900/20 rounded-lg transition-colors"
                        title="Eliminar inscripción"
                      >
                        <Trash2 className="w-5 h-5" />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

// Componente de usuarios
const UsersPanel = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('session_token');

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/admin/users`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  const getLevelBadge = (level) => {
    const colors = {
      'free': 'bg-zinc-800 text-zinc-400 border border-zinc-700',
      'principiante': 'bg-blue-900/50 text-blue-400 border border-blue-700',
      'intermedio': 'bg-purple-900/50 text-purple-400 border border-purple-700',
      'avanzado': 'bg-orange-900/50 text-orange-400 border border-orange-700',
      'premium': 'bg-pink-900/50 text-pink-400 border border-pink-700',
    };
    return colors[level] || colors.free;
  };

  if (loading) {
    return <div className="text-center py-8">Cargando usuarios...</div>;
  }

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">Usuarios Registrados ({(users || []).length})</h2>
      
      <div className="bg-zinc-900 rounded-2xl border border-zinc-800 overflow-hidden">
        <table className="w-full">
          <thead className="bg-zinc-800">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-medium">Nombre</th>
              <th className="px-4 py-3 text-left text-sm font-medium">Email</th>
              <th className="px-4 py-3 text-left text-sm font-medium">Nivel</th>
              <th className="px-4 py-3 text-left text-sm font-medium">Registro</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-800">
            {(users || []).map((user, idx) => (
              <tr key={idx} className="hover:bg-zinc-800">
                <td className="px-4 py-3 text-sm">{user.name}</td>
                <td className="px-4 py-3 text-sm text-zinc-400">{user.email}</td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getLevelBadge(user.subscription_level)}`}>
                    {user.subscription_level || 'free'}
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-zinc-500">
                  {user.created_at ? new Date(user.created_at).toLocaleDateString('es-ES') : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// Componente unificado de Usuarios y Suscriptores
const UsersAndSubscribersPanel = () => {
  const [activeTab, setActiveTab] = useState('users'); // 'users' or 'subscribers'
  const [users, setUsers] = useState([]);
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [deleting, setDeleting] = useState(null);
  const [editingUser, setEditingUser] = useState(null);
  const [availableChallenges, setAvailableChallenges] = useState([]);
  const [challengeTitles, setChallengeTitles] = useState({});
  const [selectedChallenge, setSelectedChallenge] = useState('');
  const [updatingLevel, setUpdatingLevel] = useState(false);
  const token = localStorage.getItem('session_token');

  useEffect(() => {
    fetchData();
    fetchChallenges();
  }, []);
  
  const fetchChallenges = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/challenges`);
      setAvailableChallenges(response.data.filter(c => c.status === 'active'));
    } catch (error) {
      console.error('Error fetching challenges:', error);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const [usersRes, subscribersRes] = await Promise.all([
        axios.get(`${BACKEND_URL}/api/admin/users`, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(`${BACKEND_URL}/api/admin/subscribers`, {
          headers: { Authorization: `Bearer ${token}` }
        })
      ]);
      // La API retorna {users: [], stats: {}, challenge_titles: {}} así que extraemos users
      setUsers(usersRes.data?.users || usersRes.data || []);
      setChallengeTitles(usersRes.data?.challenge_titles || {});
      setSubscribers(subscribersRes.data || []);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const deleteUser = async (userId, userName) => {
    if (!window.confirm(`¿Estás segura de eliminar al usuario "${userName}"?\n\nEsto eliminará:\n- Su cuenta\n- Sus planes nutricionales\n- Sus sesiones\n\nEsta acción no se puede deshacer.`)) return;
    
    setDeleting(userId);
    try {
      await axios.delete(`${BACKEND_URL}/api/admin/test-accounts/${userId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Usuario eliminado correctamente');
      fetchData();
    } catch (error) {
      toast.error('Error al eliminar usuario');
    } finally {
      setDeleting(null);
    }
  };

  const deleteSubscriber = async (subscriberId) => {
    if (!window.confirm('¿Eliminar este suscriptor del newsletter?')) return;
    
    setDeleting(subscriberId);
    try {
      await axios.delete(`${BACKEND_URL}/api/admin/subscribers/${subscriberId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Suscriptor eliminado');
      fetchData();
    } catch (error) {
      toast.error('Error al eliminar');
    } finally {
      setDeleting(null);
    }
  };

  const exportUsersToCSV = () => {
    const csvContent = [
      ['Nombre', 'Email', 'Nivel', 'Teléfono', 'Fecha Registro'].join(','),
      ...users.map(u => [
        u.name || '',
        u.email,
        u.subscription_level || 'free',
        u.phone || '',
        u.created_at ? new Date(u.created_at).toLocaleDateString('es-ES') : ''
      ].join(','))
    ].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `usuarios_${new Date().toISOString().split('T')[0]}.csv`;
    link.click();
    toast.success('CSV de usuarios exportado');
  };

  const exportSubscribersToCSV = () => {
    const csvContent = [
      ['Email', 'Código Descuento', 'Usado', 'Fuente', 'Fecha Suscripción'].join(','),
      ...subscribers.map(s => [
        s.email,
        s.discount_code || 'N/A',
        s.discount_used ? 'Sí' : 'No',
        s.source || 'popup',
        new Date(s.subscribed_at).toLocaleDateString('es-ES')
      ].join(','))
    ].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `suscriptores_newsletter_${new Date().toISOString().split('T')[0]}.csv`;
    link.click();
    toast.success('CSV de suscriptores exportado');
  };

  const getLevelBadge = (level) => {
    const badges = {
      'free': { bg: 'bg-zinc-800', text: 'text-zinc-400', label: 'Gratis' },
      'principiante': { bg: 'bg-blue-900/50', text: 'text-blue-400', label: 'Nivel 1' },
      'intermedio': { bg: 'bg-purple-900/50', text: 'text-purple-400', label: 'Nivel 2' },
      'avanzado': { bg: 'bg-orange-900/50', text: 'text-orange-400', label: 'Avanzado' },
      'premium': { bg: 'bg-pink-900/50', text: 'text-pink-400', label: 'Premium' },
      'challenge_only': { bg: 'bg-amber-900/50', text: 'text-amber-400', label: 'Challenge' },
    };
    return badges[level] || badges.free;
  };
  
  const updateUserLevel = async (userId, newLevel, newChallenges = null) => {
    setUpdatingLevel(true);
    try {
      await axios.put(`${BACKEND_URL}/api/admin/users/${userId}/update`, 
        { 
          subscription_level: newLevel,
          purchased_challenges: newChallenges
        },
        { headers: { Authorization: `Bearer ${token}` }}
      );
      toast.success('Usuario actualizado correctamente');
      setEditingUser(null);
      setSelectedChallenge('');
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al actualizar usuario');
    } finally {
      setUpdatingLevel(false);
    }
  };

  const filteredUsers = (users || []).filter(u => 
    u.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    u.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredSubscribers = (subscribers || []).filter(s => 
    s.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <div className="text-center py-8">Cargando datos...</div>;

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between flex-wrap gap-4">
        <h2 className="text-2xl font-bold flex items-center gap-2">
          <Users className="w-6 h-6 text-pink-500" />
          Usuarios y Suscriptores
        </h2>
        <div className="flex gap-2">
          <Button 
            onClick={activeTab === 'users' ? exportUsersToCSV : exportSubscribersToCSV} 
            className="bg-green-600 hover:bg-green-700 text-white rounded-full"
          >
            📥 Exportar CSV
          </Button>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex gap-2 bg-zinc-800 p-1 rounded-xl w-fit border border-zinc-700">
        <button
          onClick={() => setActiveTab('users')}
          className={`px-6 py-2 rounded-lg font-medium transition-all flex items-center gap-2 ${
            activeTab === 'users'
              ? 'bg-zinc-900 text-pink-500 border border-zinc-700'
              : 'text-zinc-400 hover:text-zinc-300'
          }`}
        >
          <Users className="w-4 h-4" />
          Usuarios Registrados
          <span className="bg-pink-900/50 text-pink-400 text-xs px-2 py-0.5 rounded-full">{(users || []).length}</span>
        </button>
        <button
          onClick={() => setActiveTab('subscribers')}
          className={`px-6 py-2 rounded-lg font-medium transition-all flex items-center gap-2 ${
            activeTab === 'subscribers'
              ? 'bg-zinc-900 text-pink-500 border border-zinc-700'
              : 'text-zinc-400 hover:text-zinc-300'
          }`}
        >
          <Mail className="w-4 h-4" />
          Newsletter
          <span className="bg-blue-900/50 text-blue-400 text-xs px-2 py-0.5 rounded-full">{(subscribers || []).length}</span>
        </button>
      </div>

      {/* Buscador */}
      <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={activeTab === 'users' ? "Buscar por nombre o email..." : "Buscar por email..."}
          className="w-full px-4 py-3 border border-zinc-700 rounded-xl bg-zinc-800 text-white"
        />
      </div>

      {/* Estadísticas */}
      {activeTab === 'users' ? (
        <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
          <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800 text-center">
            <p className="text-2xl font-bold text-pink-500">{(users || []).length}</p>
            <p className="text-xs text-zinc-500">Total</p>
          </div>
          <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800 text-center">
            <p className="text-2xl font-bold text-zinc-500">{(users || []).filter(u => (u.subscription_level === 'free' || !u.subscription_level) && (!u.purchased_challenges || u.purchased_challenges.length === 0)).length}</p>
            <p className="text-xs text-zinc-500">Solo Gratis</p>
          </div>
          <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800 text-center">
            <p className="text-2xl font-bold text-orange-500">{(users || []).filter(u => u.purchased_challenges && u.purchased_challenges.length > 0).length}</p>
            <p className="text-xs text-zinc-500">Con Challenge</p>
          </div>
          <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800 text-center">
            <p className="text-2xl font-bold text-blue-500">{(users || []).filter(u => u.subscription_level === 'principiante').length}</p>
            <p className="text-xs text-zinc-500">Nivel 1</p>
          </div>
          <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800 text-center">
            <p className="text-2xl font-bold text-purple-500">{(users || []).filter(u => u.subscription_level === 'intermedio').length}</p>
            <p className="text-xs text-zinc-500">Nivel 2</p>
          </div>
          <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800 text-center">
            <p className="text-2xl font-bold text-pink-500">{(users || []).filter(u => u.subscription_level === 'premium').length}</p>
            <p className="text-xs text-zinc-500">Premium</p>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-3 gap-4">
          <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800 text-center">
            <p className="text-2xl font-bold text-pink-500">{(subscribers || []).length}</p>
            <p className="text-xs text-zinc-500">Total Suscriptores</p>
          </div>
          <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800 text-center">
            <p className="text-2xl font-bold text-green-500">{(subscribers || []).filter(s => s.discount_used).length}</p>
            <p className="text-xs text-zinc-500">Descuentos Usados</p>
          </div>
          <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800 text-center">
            <p className="text-2xl font-bold text-blue-500">{(subscribers || []).filter(s => !s.discount_used).length}</p>
            <p className="text-xs text-zinc-500">Pendientes</p>
          </div>
        </div>
      )}

      {/* Tabla de Usuarios */}
      {activeTab === 'users' && (
        <div className="bg-zinc-900 rounded-2xl border border-zinc-800 overflow-hidden">
          <div className="max-h-[500px] overflow-y-auto">
            <table className="w-full">
              <thead className="bg-zinc-800 sticky top-0">
                <tr>
                  <th className="text-left p-4 font-medium">Nombre</th>
                  <th className="text-left p-4 font-medium">Email</th>
                  <th className="text-left p-4 font-medium">Nivel</th>
                  <th className="text-left p-4 font-medium">Teléfono</th>
                  <th className="text-left p-4 font-medium">Registro</th>
                  <th className="text-center p-4 font-medium">Acciones</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-100">
                {filteredUsers.map((user, idx) => {
                  const badge = getLevelBadge(user.subscription_level);
                  return (
                    <tr key={idx} className="hover:bg-zinc-800">
                      <td className="p-4">
                        <div className="font-medium">{user.name || '-'}</div>
                        {user.role === 'admin' && (
                          <span className="text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded">Admin</span>
                        )}
                      </td>
                      <td className="p-4 text-sm text-zinc-400">{user.email}</td>
                      <td className="p-4">
                        <div className="flex items-center gap-2">
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${badge.bg} ${badge.text}`}>
                            {badge.label}
                          </span>
                          {user.role !== 'admin' && (
                            <button
                              onClick={() => {
                                setEditingUser(user);
                                setSelectedChallenge('');
                                fetchChallenges(); // Refrescar por si se creó/activó un challenge después del mount
                              }}
                              className="p-1 text-zinc-400 hover:text-pink-500 hover:bg-pink-500/10 rounded transition-colors"
                              title="Cambiar nivel"
                            >
                              <Edit className="w-3 h-3" />
                            </button>
                          )}
                        </div>
                        {user.purchased_challenges?.length > 0 && (
                          <p className="text-xs text-orange-400 mt-1">
                            🏆 {user.purchased_challenges
                              .map(chId => challengeTitles[chId] || availableChallenges.find(c => c.challenge_id === chId)?.title || chId)
                              .join(', ')}
                          </p>
                        )}
                      </td>
                      <td className="p-4 text-sm text-zinc-500">{user.phone || '-'}</td>
                      <td className="p-4 text-sm text-zinc-500">
                        {user.created_at ? new Date(user.created_at).toLocaleDateString('es-ES') : '-'}
                      </td>
                      <td className="p-4 text-center">
                        {user.role !== 'admin' ? (
                          <button
                            onClick={() => deleteUser(user.user_id, user.name || user.email)}
                            disabled={deleting === user.user_id}
                            className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors disabled:opacity-50"
                            title="Eliminar usuario"
                          >
                            {deleting === user.user_id ? (
                              <RefreshCw className="w-4 h-4 animate-spin" />
                            ) : (
                              <Trash2 className="w-4 h-4" />
                            )}
                          </button>
                        ) : (
                          <span className="text-zinc-300" title="No se puede eliminar admin">
                            <Lock className="w-4 h-4 inline" />
                          </span>
                        )}
                      </td>
                    </tr>
                  );
                })}
                {filteredUsers.length === 0 && (
                  <tr>
                    <td colSpan="6" className="p-8 text-center text-zinc-400">
                      No se encontraron usuarios
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Tabla de Suscriptores Newsletter */}
      {activeTab === 'subscribers' && (
        <div className="bg-zinc-900 rounded-2xl border border-zinc-800 overflow-hidden">
          <div className="max-h-[500px] overflow-y-auto">
            <table className="w-full">
              <thead className="bg-zinc-800 sticky top-0">
                <tr>
                  <th className="text-left p-4 font-medium">Email</th>
                  <th className="text-left p-4 font-medium">Código Descuento</th>
                  <th className="text-left p-4 font-medium">Estado</th>
                  <th className="text-left p-4 font-medium">Fuente</th>
                  <th className="text-left p-4 font-medium">Fecha</th>
                  <th className="text-center p-4 font-medium">Acciones</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-800">
                {filteredSubscribers.map((sub, idx) => (
                  <tr key={idx} className="hover:bg-zinc-800">
                    <td className="p-4 font-medium">{sub.email}</td>
                    <td className="p-4">
                      <code className="bg-zinc-800 px-2 py-1 rounded text-sm text-zinc-300 border border-zinc-700">
                        {sub.discount_code || 'N/A'}
                      </code>
                    </td>
                    <td className="p-4">
                      {sub.discount_used ? (
                        <span className="px-2 py-1 bg-green-900/50 text-green-400 rounded-full text-xs font-medium">
                          ✓ Usado
                        </span>
                      ) : (
                        <span className="px-2 py-1 bg-amber-900/50 text-amber-400 rounded-full text-xs font-medium">
                          Pendiente
                        </span>
                      )}
                    </td>
                    <td className="p-4 text-sm text-zinc-500">{sub.source || 'popup'}</td>
                    <td className="p-4 text-sm text-zinc-500">
                      {sub.subscribed_at ? new Date(sub.subscribed_at).toLocaleDateString('es-ES') : '-'}
                    </td>
                    <td className="p-4 text-center">
                      <button
                        onClick={() => deleteSubscriber(sub.subscriber_id || sub._id)}
                        disabled={deleting === (sub.subscriber_id || sub._id)}
                        className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors disabled:opacity-50"
                        title="Eliminar suscriptor"
                      >
                        {deleting === (sub.subscriber_id || sub._id) ? (
                          <RefreshCw className="w-4 h-4 animate-spin" />
                        ) : (
                          <Trash2 className="w-4 h-4" />
                        )}
                      </button>
                    </td>
                  </tr>
                ))}
                {filteredSubscribers.length === 0 && (
                  <tr>
                    <td colSpan="6" className="p-8 text-center text-zinc-400">
                      No se encontraron suscriptores
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
      
      {/* Modal para editar usuario (nivel + challenges) */}
      {editingUser && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
          <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 max-w-lg w-full max-h-[90vh] overflow-y-auto">
            <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <Edit className="w-5 h-5 text-pink-500" />
              Editar Usuario
            </h3>
            
            <div className="mb-4 p-3 bg-zinc-800/50 rounded-xl">
              <p className="text-white font-medium">{editingUser.name || 'Sin nombre'}</p>
              <p className="text-zinc-400 text-sm">{editingUser.email}</p>
            </div>
            
            <div className="space-y-6">
              {/* SECCIÓN 1: Nivel de Programa */}
              <div className="p-4 bg-zinc-800/30 border border-zinc-700 rounded-xl">
                <h4 className="text-sm font-bold text-pink-400 mb-3 flex items-center gap-2">
                  <Star className="w-4 h-4" />
                  Nivel de Programa
                </h4>
                <select
                  className="w-full px-4 py-2 rounded-xl bg-zinc-800 border border-zinc-700 text-white"
                  value={editingUser.newLevel || editingUser.subscription_level || 'free'}
                  onChange={(e) => setEditingUser({...editingUser, newLevel: e.target.value})}
                >
                  <option value="free">🆓 Gratuito (sin programa)</option>
                  <option value="principiante">🥉 Nivel 1 - Principiante</option>
                  <option value="intermedio">🥈 Nivel 2 - Intermedio</option>
                  <option value="premium">⭐ Premium</option>
                </select>
                <p className="text-zinc-500 text-xs mt-2">Define el acceso a los programas de entrenamiento</p>
              </div>
              
              {/* SECCIÓN 2: Challenges Asignados */}
              <div className="p-4 bg-orange-500/5 border border-orange-500/20 rounded-xl">
                <h4 className="text-sm font-bold text-orange-400 mb-3 flex items-center gap-2">
                  <Trophy className="w-4 h-4" />
                  Challenges Asignados
                </h4>
                
                {/* Lista de challenges actuales */}
                {(editingUser.purchased_challenges?.length > 0 || editingUser.newChallenges?.length > 0) ? (
                  <div className="space-y-2 mb-3">
                    {(editingUser.newChallenges || editingUser.purchased_challenges || []).map((chId) => {
                      const ch = availableChallenges.find(c => c.challenge_id === chId);
                      return (
                        <div key={chId} className="flex items-center justify-between bg-zinc-800/50 px-3 py-2 rounded-lg">
                          <span className="text-white text-sm">{ch?.title || chId}</span>
                          <button
                            onClick={() => {
                              const current = editingUser.newChallenges || editingUser.purchased_challenges || [];
                              setEditingUser({
                                ...editingUser,
                                newChallenges: current.filter(c => c !== chId)
                              });
                            }}
                            className="text-red-400 hover:text-red-300 p-1"
                          >
                            <X className="w-4 h-4" />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <p className="text-zinc-500 text-sm mb-3">No tiene challenges asignados</p>
                )}
                
                {/* Agregar nuevo challenge */}
                <div className="flex gap-2">
                  <select
                    className="flex-1 px-3 py-2 rounded-lg bg-zinc-800 border border-zinc-700 text-white text-sm"
                    value={selectedChallenge}
                    onChange={(e) => setSelectedChallenge(e.target.value)}
                  >
                    <option value="">+ Agregar challenge...</option>
                    {availableChallenges
                      .filter(ch => !(editingUser.newChallenges || editingUser.purchased_challenges || []).includes(ch.challenge_id))
                      .map(ch => (
                        <option key={ch.challenge_id} value={ch.challenge_id}>
                          {ch.title}
                        </option>
                      ))}
                  </select>
                  <Button
                    onClick={() => {
                      if (selectedChallenge) {
                        const current = editingUser.newChallenges || editingUser.purchased_challenges || [];
                        if (!current.includes(selectedChallenge)) {
                          setEditingUser({
                            ...editingUser,
                            newChallenges: [...current, selectedChallenge]
                          });
                        }
                        setSelectedChallenge('');
                      }
                    }}
                    disabled={!selectedChallenge}
                    size="sm"
                    className="bg-orange-600 hover:bg-orange-700 text-white"
                  >
                    Agregar
                  </Button>
                </div>
                <p className="text-zinc-500 text-xs mt-2">Los challenges son independientes del nivel de programa</p>
              </div>
              
              {/* Botones de acción */}
              <div className="flex gap-3 pt-2">
                <Button
                  onClick={() => {
                    setEditingUser(null);
                    setSelectedChallenge('');
                  }}
                  variant="outline"
                  className="flex-1 border-zinc-700 text-zinc-300"
                >
                  Cancelar
                </Button>
                <Button
                  onClick={() => {
                    const newLevel = editingUser.newLevel || editingUser.subscription_level || 'free';
                    const newChallenges = editingUser.newChallenges !== undefined 
                      ? editingUser.newChallenges 
                      : editingUser.purchased_challenges || [];
                    updateUserLevel(editingUser.user_id, newLevel, newChallenges);
                  }}
                  disabled={updatingLevel}
                  className="flex-1 bg-pink-600 hover:bg-pink-700 text-white"
                >
                  {updatingLevel ? (
                    <>
                      <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                      Guardando...
                    </>
                  ) : (
                    'Guardar Cambios'
                  )}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Componente de formularios de nutrición
const NutritionFormsPanel = () => {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedForm, setSelectedForm] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const token = localStorage.getItem('session_token');

  useEffect(() => {
    fetchForms();
  }, []);

  const fetchForms = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/admin/nutrition-forms`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setForms(response.data);
    } catch (error) {
      console.error('Error fetching forms:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (formId, status) => {
    try {
      await axios.put(`${BACKEND_URL}/api/admin/nutrition-forms/${formId}/status`, 
        { status },
        { headers: { Authorization: `Bearer ${token}` }}
      );
      toast.success('Estado actualizado');
      fetchForms();
    } catch (error) {
      toast.error('Error al actualizar');
    }
  };

  const deleteForm = async (formId) => {
    if (!window.confirm('¿Estás seguro de eliminar este plan nutricional? Esta acción no se puede deshacer.')) {
      return;
    }
    setDeleting(formId);
    try {
      await axios.delete(`${BACKEND_URL}/api/admin/nutrition-forms/${formId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Plan nutricional eliminado');
      fetchForms();
    } catch (error) {
      toast.error('Error al eliminar el plan');
    } finally {
      setDeleting(null);
    }
  };

  if (loading) {
    return <div className="text-center py-8">Cargando planes nutricionales...</div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">Planes Nutricionales ({forms.length})</h2>
        <Button variant="outline" onClick={fetchForms} className="rounded-full">
          <RefreshCw className="w-4 h-4 mr-2" />
          Actualizar
        </Button>
      </div>
      
      {forms.length === 0 ? (
        <div className="bg-zinc-900 rounded-2xl p-8 text-center border border-zinc-800">
          <Utensils className="w-12 h-12 text-zinc-300 mx-auto mb-4" />
          <p className="text-zinc-500">No hay planes nutricionales creados aún</p>
        </div>
      ) : (
        <div className="space-y-4">
          {forms.map((form, idx) => (
            <div key={idx} className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-bold">{form.nombre_completo}</h3>
                  <p className="text-sm text-zinc-500">{form.correo_electronico}</p>
                  {form.nutrition_plan && (
                    <p className="text-xs text-pink-600 mt-1">
                      {form.nutrition_plan.calorias_diarias} kcal/día • {form.nutrition_plan.comidas_por_dia} comidas
                    </p>
                  )}
                </div>
                <div className="flex items-center gap-2">
                  <select
                    value={form.status}
                    onChange={(e) => updateStatus(form.form_id, e.target.value)}
                    className={`px-3 py-1 rounded-full text-sm font-medium ${
                      form.status === 'pending' ? 'bg-yellow-100 text-yellow-700' :
                      form.status === 'in_review' ? 'bg-blue-100 text-blue-700' :
                      'bg-green-100 text-green-700'
                    }`}
                  >
                    <option value="pending">Pendiente</option>
                    <option value="in_review">En revisión</option>
                    <option value="completed">Completado</option>
                  </select>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setSelectedForm(selectedForm === form.form_id ? null : form.form_id)}
                  >
                    <Eye className="w-4 h-4" />
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => deleteForm(form.form_id)}
                    disabled={deleting === form.form_id}
                    className="text-red-500 hover:bg-red-50 hover:text-red-600"
                  >
                    {deleting === form.form_id ? (
                      <RefreshCw className="w-4 h-4 animate-spin" />
                    ) : (
                      <Trash2 className="w-4 h-4" />
                    )}
                  </Button>
                </div>
              </div>
              
              {selectedForm === form.form_id && (
                <div className="mt-4 pt-4 border-t border-zinc-800">
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm mb-4">
                    <div><strong>Edad:</strong> {form.edad} años</div>
                    <div><strong>Estatura:</strong> {form.estatura} cm</div>
                    <div><strong>Peso:</strong> {form.peso} kg</div>
                    <div><strong>Comidas/día:</strong> {form.numero_comidas}</div>
                    <div><strong>Nivel actividad:</strong> {form.nivel_actividad}</div>
                    <div><strong>Objetivo:</strong> {form.objetivo}</div>
                    <div className="col-span-2"><strong>Alergias:</strong> {form.alergias || 'Ninguna'}</div>
                  </div>
                  
                  {form.nutrition_plan && (
                    <div className="bg-pink-50 rounded-xl p-4 mt-4">
                      <h4 className="font-bold text-pink-700 mb-2">Plan Calculado</h4>
                      <div className="grid grid-cols-4 gap-2 text-sm">
                        <div className="bg-zinc-900 rounded-lg p-2 text-center">
                          <div className="font-bold text-lg">{form.nutrition_plan.calorias_diarias}</div>
                          <div className="text-xs text-zinc-500">Calorías</div>
                        </div>
                        <div className="bg-zinc-900 rounded-lg p-2 text-center">
                          <div className="font-bold text-lg">{form.nutrition_plan.macros?.proteinas_g}g</div>
                          <div className="text-xs text-zinc-500">Proteínas</div>
                        </div>
                        <div className="bg-zinc-900 rounded-lg p-2 text-center">
                          <div className="font-bold text-lg">{form.nutrition_plan.macros?.carbohidratos_g}g</div>
                          <div className="text-xs text-zinc-500">Carbos</div>
                        </div>
                        <div className="bg-zinc-900 rounded-lg p-2 text-center">
                          <div className="font-bold text-lg">{form.nutrition_plan.macros?.grasas_g}g</div>
                          <div className="text-xs text-zinc-500">Grasas</div>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {form.selected_foods && Object.keys(form.selected_foods).length > 0 && (
                    <div className="bg-green-50 rounded-xl p-4 mt-4">
                      <h4 className="font-bold text-green-700 mb-2">Alimentos Seleccionados</h4>
                      <p className="text-sm text-green-600">
                        {Object.keys(form.selected_foods).length} selecciones guardadas
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// Panel para crear cuentas de prueba
const TestAccountsPanel = () => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    subscription_level: 'free'
  });
  const token = localStorage.getItem('session_token');

  const subscriptionLevels = [
    { value: 'free', label: '🆓 Gratuito', color: 'bg-zinc-800 text-zinc-300' },
    { value: 'challenge_only', label: '🏆 Challenge', color: 'bg-orange-500/20 text-orange-400' },
    { value: 'principiante', label: '🥉 Nivel 1 - Principiante', color: 'bg-blue-500/20 text-blue-400' },
    { value: 'intermedio', label: '🥈 Nivel 2 - Intermedio', color: 'bg-purple-500/20 text-purple-400' },
    { value: 'premium', label: '⭐ Premium', color: 'bg-pink-500/20 text-pink-400' },
  ];
  
  // Estado para challenges disponibles
  const [availableChallenges, setAvailableChallenges] = useState([]);
  const [selectedChallengeForUser, setSelectedChallengeForUser] = useState({});

  useEffect(() => {
    fetchAccounts();
    fetchAvailableChallenges();
  }, []);
  
  const fetchAvailableChallenges = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/challenges`);
      setAvailableChallenges(response.data.filter(c => c.status === 'active'));
    } catch (error) {
      console.error('Error fetching challenges:', error);
    }
  };

  const fetchAccounts = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/admin/test-accounts`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAccounts(response.data);
    } catch (error) {
      console.error('Error fetching accounts:', error);
    } finally {
      setLoading(false);
    }
  };

  const createAccount = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.password) {
      toast.error('Completa todos los campos');
      return;
    }
    
    setCreating(true);
    try {
      await axios.post(`${BACKEND_URL}/api/admin/test-accounts`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success(`Cuenta de prueba creada: ${formData.email}`);
      setFormData({ name: '', email: '', password: '', subscription_level: 'free' });
      fetchAccounts();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al crear cuenta');
    } finally {
      setCreating(false);
    }
  };

  const deleteAccount = async (userId) => {
    if (!window.confirm('¿Eliminar esta cuenta de prueba?')) return;
    
    try {
      await axios.delete(`${BACKEND_URL}/api/admin/test-accounts/${userId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Cuenta eliminada');
      fetchAccounts();
    } catch (error) {
      toast.error('Error al eliminar cuenta');
    }
  };

  const updateLevel = async (userId, newLevel, challengeId = null) => {
    try {
      await axios.put(`${BACKEND_URL}/api/admin/test-accounts/${userId}/level`, 
        { 
          subscription_level: newLevel,
          challenge_id: challengeId 
        },
        { headers: { Authorization: `Bearer ${token}` }}
      );
      toast.success('Nivel actualizado');
      fetchAccounts();
      // Limpiar selección de challenge
      setSelectedChallengeForUser(prev => ({...prev, [userId]: null}));
    } catch (error) {
      toast.error('Error al actualizar nivel');
    }
  };
  
  const handleLevelChange = (userId, newLevel) => {
    if (newLevel === 'challenge_only') {
      // Mostrar selector de challenge
      setSelectedChallengeForUser(prev => ({...prev, [userId]: 'selecting'}));
    } else {
      updateLevel(userId, newLevel);
    }
  };
  
  const confirmChallengeAssignment = (userId, challengeId) => {
    if (!challengeId) {
      toast.error('Selecciona un challenge');
      return;
    }
    updateLevel(userId, 'challenge_only', challengeId);
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-white">Cuentas de Prueba</h2>
      
      {/* Formulario para crear cuenta */}
      <div className="bg-zinc-900 rounded-2xl p-6 border border-zinc-800">
        <h3 className="font-bold mb-4 flex items-center gap-2 text-white">
          <UserPlus className="w-5 h-5 text-pink-500" />
          Crear Nueva Cuenta de Prueba
        </h3>
        
        <form onSubmit={createAccount} className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1 text-zinc-300">Nombre</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              placeholder="Usuario Prueba"
              className="w-full px-4 py-2 border border-zinc-700 rounded-xl focus:border-pink-500 focus:outline-none bg-zinc-800 text-white placeholder:text-zinc-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1 text-zinc-300">Email</label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              placeholder="test@ejemplo.com"
              className="w-full px-4 py-2 border border-zinc-700 rounded-xl focus:border-pink-500 focus:outline-none bg-zinc-800 text-white placeholder:text-zinc-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1 text-zinc-300">Contraseña</label>
            <input
              type="text"
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
              placeholder="test123"
              className="w-full px-4 py-2 border border-zinc-700 rounded-xl focus:border-pink-500 focus:outline-none bg-zinc-800 text-white placeholder:text-zinc-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1 text-zinc-300">Nivel de Suscripción</label>
            <select
              value={formData.subscription_level}
              onChange={(e) => setFormData({...formData, subscription_level: e.target.value})}
              className="w-full px-4 py-2 border border-zinc-700 rounded-xl focus:border-pink-500 focus:outline-none bg-zinc-800 text-white"
            >
              {subscriptionLevels.map(level => (
                <option key={level.value} value={level.value}>{level.label}</option>
              ))}
            </select>
          </div>
          <div className="md:col-span-2">
            <Button
              type="submit"
              disabled={creating}
              className="w-full bg-pink-600 hover:bg-pink-500 text-white rounded-full py-3"
            >
              {creating ? (
                <>
                  <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                  Creando...
                </>
              ) : (
                <>
                  <UserPlus className="w-4 h-4 mr-2" />
                  Crear Cuenta de Prueba
                </>
              )}
            </Button>
          </div>
        </form>
      </div>

      {/* Lista de cuentas */}
      <div className="bg-zinc-900 rounded-2xl p-6 border border-zinc-800">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-bold text-white">Cuentas Existentes ({accounts.length})</h3>
          <Button variant="outline" size="sm" onClick={fetchAccounts} className="rounded-full border-zinc-700 text-zinc-300 hover:bg-zinc-800">
            <RefreshCw className="w-4 h-4" />
          </Button>
        </div>
        
        {loading ? (
          <div className="text-center py-8 text-zinc-500">Cargando...</div>
        ) : accounts.length === 0 ? (
          <div className="text-center py-8 text-zinc-500">
            No hay cuentas de prueba creadas
          </div>
        ) : (
          <div className="space-y-3">
            {accounts.map((account) => {
              const levelInfo = subscriptionLevels.find(l => l.value === account.subscription_level) || subscriptionLevels[0];
              const isSelectingChallenge = selectedChallengeForUser[account.user_id] === 'selecting';
              
              return (
                <div key={account.user_id} className="p-4 border border-zinc-800 rounded-xl">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="font-bold text-white">{account.name}</p>
                      <p className="text-sm text-zinc-500">{account.email}</p>
                      {account.purchased_challenges?.length > 0 && (
                        <p className="text-xs text-orange-400 mt-1">
                          🏆 Challenges: {account.purchased_challenges.join(', ')}
                        </p>
                      )}
                    </div>
                    <div className="flex items-center gap-2">
                      <select
                        value={account.subscription_level}
                        onChange={(e) => handleLevelChange(account.user_id, e.target.value)}
                        className={`px-3 py-1 rounded-full text-sm font-medium ${levelInfo.color}`}
                      >
                        {subscriptionLevels.map(level => (
                          <option key={level.value} value={level.value}>{level.label}</option>
                        ))}
                      </select>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => deleteAccount(account.user_id)}
                        className="text-red-500 hover:bg-red-500/10 border-red-500/30"
                      >
                        <Trash2 className="w-4 h-4" />
                      </Button>
                    </div>
                  </div>
                  
                  {/* Selector de Challenge cuando se elige "Challenge" */}
                  {isSelectingChallenge && (
                    <div className="mt-3 p-3 bg-orange-500/10 border border-orange-500/30 rounded-xl">
                      <p className="text-sm text-orange-400 mb-2">Selecciona el challenge a asignar:</p>
                      <div className="flex gap-2">
                        <select
                          className="flex-1 px-3 py-2 rounded-lg bg-zinc-800 border border-zinc-700 text-white text-sm"
                          onChange={(e) => setSelectedChallengeForUser(prev => ({...prev, [account.user_id]: e.target.value}))}
                          defaultValue=""
                        >
                          <option value="">-- Seleccionar Challenge --</option>
                          {availableChallenges.map(ch => (
                            <option key={ch.challenge_id} value={ch.challenge_id}>
                              {ch.title}
                            </option>
                          ))}
                        </select>
                        <Button
                          size="sm"
                          onClick={() => confirmChallengeAssignment(account.user_id, selectedChallengeForUser[account.user_id])}
                          className="bg-orange-500 hover:bg-orange-600 text-white"
                        >
                          Asignar
                        </Button>
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => setSelectedChallengeForUser(prev => ({...prev, [account.user_id]: null}))}
                          className="border-zinc-700 text-zinc-400"
                        >
                          Cancelar
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

// Componente de Testimonios/Reviews
const TestimonialsPanel = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [stats, setStats] = useState({ total: 0, approved: 0, pending: 0 });
  const [loading, setLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [editingTestimonial, setEditingTestimonial] = useState(null);
  const [filter, setFilter] = useState('all'); // all, approved, pending, featured
  const [newTestimonial, setNewTestimonial] = useState({
    name: '',
    rating: 5,
    comment: '',
    image_url: '',
    featured: false
  });
  const token = localStorage.getItem('session_token');

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/admin/testimonials`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTestimonials(response.data.testimonials || []);
      setStats(response.data.stats || { total: 0, approved: 0, pending: 0 });
    } catch (error) {
      console.error('Error:', error);
      toast.error('Error al cargar testimonios');
    } finally {
      setLoading(false);
    }
  };

  const createTestimonial = async (e) => {
    e.preventDefault();
    if (!newTestimonial.name || !newTestimonial.comment) {
      toast.error('Nombre y comentario son requeridos');
      return;
    }
    try {
      await axios.post(`${BACKEND_URL}/api/admin/testimonials`, newTestimonial, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Testimonio creado');
      setShowCreateModal(false);
      setNewTestimonial({ name: '', rating: 5, comment: '', image_url: '', featured: false });
      fetchTestimonials();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al crear');
    }
  };

  const updateTestimonial = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${BACKEND_URL}/api/admin/testimonials/${editingTestimonial.review_id}`, editingTestimonial, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Testimonio actualizado');
      setEditingTestimonial(null);
      fetchTestimonials();
    } catch (error) {
      toast.error('Error al actualizar');
    }
  };

  const approveTestimonial = async (reviewId) => {
    try {
      await axios.put(`${BACKEND_URL}/api/admin/testimonials/${reviewId}/approve`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Testimonio aprobado');
      fetchTestimonials();
    } catch (error) {
      toast.error('Error al aprobar');
    }
  };

  const toggleFeatured = async (reviewId) => {
    try {
      await axios.put(`${BACKEND_URL}/api/admin/testimonials/${reviewId}/feature`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchTestimonials();
    } catch (error) {
      toast.error('Error al cambiar destacado');
    }
  };

  const deleteTestimonial = async (reviewId) => {
    if (!window.confirm('¿Eliminar este testimonio?')) return;
    try {
      await axios.delete(`${BACKEND_URL}/api/admin/testimonials/${reviewId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Testimonio eliminado');
      fetchTestimonials();
    } catch (error) {
      toast.error('Error al eliminar');
    }
  };

  const filteredTestimonials = testimonials.filter(t => {
    if (filter === 'approved') return t.approved;
    if (filter === 'pending') return !t.approved;
    if (filter === 'featured') return t.featured;
    return true;
  });

  const renderStars = (rating, onChange) => {
    return (
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map(star => (
          <button
            key={star}
            type="button"
            onClick={() => onChange && onChange(star)}
            className={`${onChange ? 'cursor-pointer hover:scale-110' : ''} transition-transform`}
          >
            <Star 
              className={`w-5 h-5 ${star <= rating ? 'text-yellow-400 fill-yellow-400' : 'text-zinc-600'}`} 
            />
          </button>
        ))}
      </div>
    );
  };

  if (loading) return <div className="text-center py-8 text-zinc-400">Cargando testimonios...</div>;

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <h2 className="text-2xl font-bold flex items-center gap-2 text-white">
          <MessageSquare className="w-6 h-6 text-pink-500" />
          Testimonios y Reviews
        </h2>
        <div className="flex gap-2">
          <Button 
            onClick={() => setShowCreateModal(true)}
            className="bg-pink-600 hover:bg-pink-700 text-white rounded-xl"
          >
            + Crear Testimonio
          </Button>
          <Button onClick={fetchTestimonials} variant="outline" className="rounded-xl border-zinc-700 text-zinc-300">
            <RefreshCw className="w-4 h-4" />
          </Button>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl p-5 text-white">
          <MessageSquare className="w-6 h-6 mb-2 opacity-80" />
          <p className="text-2xl font-bold">{stats.total}</p>
          <p className="text-blue-100 text-sm">Total</p>
        </div>
        <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-2xl p-5 text-white">
          <CheckCircle className="w-6 h-6 mb-2 opacity-80" />
          <p className="text-2xl font-bold">{stats.approved}</p>
          <p className="text-green-100 text-sm">Aprobados</p>
        </div>
        <div className="bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl p-5 text-white">
          <Star className="w-6 h-6 mb-2 opacity-80" />
          <p className="text-2xl font-bold">{testimonials.filter(t => t.featured).length}</p>
          <p className="text-amber-100 text-sm">Destacados</p>
        </div>
        <div className="bg-gradient-to-br from-red-500 to-red-600 rounded-2xl p-5 text-white">
          <Bell className="w-6 h-6 mb-2 opacity-80" />
          <p className="text-2xl font-bold">{stats.pending}</p>
          <p className="text-red-100 text-sm">Pendientes</p>
        </div>
      </div>

      {/* Filters */}
      <div className="flex gap-2 flex-wrap">
        {['all', 'approved', 'pending', 'featured'].map(f => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
              filter === f 
                ? 'bg-pink-600 text-white' 
                : 'bg-zinc-800 text-zinc-400 hover:bg-zinc-700'
            }`}
          >
            {f === 'all' && 'Todos'}
            {f === 'approved' && '✓ Aprobados'}
            {f === 'pending' && '⏳ Pendientes'}
            {f === 'featured' && '⭐ Destacados'}
          </button>
        ))}
      </div>

      {/* Testimonials List */}
      <div className="space-y-4">
        {filteredTestimonials.length === 0 ? (
          <div className="text-center py-12 bg-zinc-900 rounded-2xl border border-zinc-800">
            <MessageSquare className="w-12 h-12 mx-auto mb-3 text-zinc-600" />
            <p className="text-zinc-500">No hay testimonios {filter !== 'all' && 'en este filtro'}</p>
          </div>
        ) : (
          filteredTestimonials.map((testimonial) => (
            <div 
              key={testimonial.review_id} 
              className={`bg-zinc-900 rounded-2xl p-5 border ${
                testimonial.featured ? 'border-yellow-500/50' : 'border-zinc-800'
              }`}
            >
              <div className="flex flex-col md:flex-row md:items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <h3 className="font-bold text-white">{testimonial.name}</h3>
                    {testimonial.featured && (
                      <span className="bg-yellow-500/20 text-yellow-400 text-xs px-2 py-1 rounded-full">
                        ⭐ Destacado
                      </span>
                    )}
                    {!testimonial.approved && (
                      <span className="bg-red-500/20 text-red-400 text-xs px-2 py-1 rounded-full">
                        Pendiente
                      </span>
                    )}
                  </div>
                  <div className="mb-2">{renderStars(testimonial.rating)}</div>
                  <p className="text-zinc-400">{testimonial.comment}</p>
                  <p className="text-xs text-zinc-600 mt-2">
                    {new Date(testimonial.created_at).toLocaleDateString('es-ES', {
                      day: 'numeric', month: 'short', year: 'numeric'
                    })}
                  </p>
                </div>
                <div className="flex gap-2">
                  {!testimonial.approved && (
                    <Button 
                      onClick={() => approveTestimonial(testimonial.review_id)}
                      size="sm"
                      className="bg-green-600 hover:bg-green-700 text-white rounded-lg"
                    >
                      <CheckCircle className="w-4 h-4" />
                    </Button>
                  )}
                  <Button 
                    onClick={() => toggleFeatured(testimonial.review_id)}
                    size="sm"
                    variant="outline"
                    className={`rounded-lg border-zinc-700 ${testimonial.featured ? 'text-yellow-400' : 'text-zinc-400'}`}
                  >
                    <Star className="w-4 h-4" />
                  </Button>
                  <Button 
                    onClick={() => setEditingTestimonial(testimonial)}
                    size="sm"
                    variant="outline"
                    className="rounded-lg border-zinc-700 text-zinc-400"
                  >
                    <Edit className="w-4 h-4" />
                  </Button>
                  <Button 
                    onClick={() => deleteTestimonial(testimonial.review_id)}
                    size="sm"
                    variant="outline"
                    className="rounded-lg border-zinc-700 text-red-400 hover:bg-red-500/10"
                  >
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Create Modal */}
      {showCreateModal && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
          <div className="bg-zinc-900 rounded-2xl p-6 max-w-lg w-full border border-zinc-800">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-bold text-white">Crear Testimonio</h3>
              <button onClick={() => setShowCreateModal(false)} className="text-zinc-400 hover:text-white">
                <X className="w-5 h-5" />
              </button>
            </div>
            <form onSubmit={createTestimonial} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2 text-zinc-300">Nombre *</label>
                <input
                  type="text"
                  value={newTestimonial.name}
                  onChange={(e) => setNewTestimonial({...newTestimonial, name: e.target.value})}
                  className="w-full px-4 py-3 rounded-xl bg-zinc-800 border border-zinc-700 text-white"
                  placeholder="Nombre del cliente"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 text-zinc-300">Calificación</label>
                {renderStars(newTestimonial.rating, (rating) => setNewTestimonial({...newTestimonial, rating}))}
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 text-zinc-300">Comentario *</label>
                <textarea
                  value={newTestimonial.comment}
                  onChange={(e) => setNewTestimonial({...newTestimonial, comment: e.target.value})}
                  className="w-full px-4 py-3 rounded-xl bg-zinc-800 border border-zinc-700 text-white h-32"
                  placeholder="Escribe el testimonio..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 text-zinc-300">URL de Imagen (opcional)</label>
                <input
                  type="url"
                  value={newTestimonial.image_url}
                  onChange={(e) => setNewTestimonial({...newTestimonial, image_url: e.target.value})}
                  className="w-full px-4 py-3 rounded-xl bg-zinc-800 border border-zinc-700 text-white"
                  placeholder="https://..."
                />
              </div>
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="featured"
                  checked={newTestimonial.featured}
                  onChange={(e) => setNewTestimonial({...newTestimonial, featured: e.target.checked})}
                  className="rounded"
                />
                <label htmlFor="featured" className="text-sm text-zinc-300">Marcar como destacado</label>
              </div>
              <div className="flex gap-3 pt-4">
                <Button type="button" variant="outline" onClick={() => setShowCreateModal(false)} className="flex-1 rounded-xl border-zinc-700 text-zinc-300">
                  Cancelar
                </Button>
                <Button type="submit" className="flex-1 bg-pink-600 hover:bg-pink-700 text-white rounded-xl">
                  Crear
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {editingTestimonial && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
          <div className="bg-zinc-900 rounded-2xl p-6 max-w-lg w-full border border-zinc-800">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-bold text-white">Editar Testimonio</h3>
              <button onClick={() => setEditingTestimonial(null)} className="text-zinc-400 hover:text-white">
                <X className="w-5 h-5" />
              </button>
            </div>
            <form onSubmit={updateTestimonial} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2 text-zinc-300">Nombre</label>
                <input
                  type="text"
                  value={editingTestimonial.name}
                  onChange={(e) => setEditingTestimonial({...editingTestimonial, name: e.target.value})}
                  className="w-full px-4 py-3 rounded-xl bg-zinc-800 border border-zinc-700 text-white"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 text-zinc-300">Calificación</label>
                {renderStars(editingTestimonial.rating, (rating) => setEditingTestimonial({...editingTestimonial, rating}))}
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 text-zinc-300">Comentario</label>
                <textarea
                  value={editingTestimonial.comment}
                  onChange={(e) => setEditingTestimonial({...editingTestimonial, comment: e.target.value})}
                  className="w-full px-4 py-3 rounded-xl bg-zinc-800 border border-zinc-700 text-white h-32"
                />
              </div>
              <div className="flex items-center gap-4">
                <label className="flex items-center gap-2 text-zinc-300">
                  <input
                    type="checkbox"
                    checked={editingTestimonial.approved}
                    onChange={(e) => setEditingTestimonial({...editingTestimonial, approved: e.target.checked})}
                    className="rounded"
                  />
                  Aprobado
                </label>
                <label className="flex items-center gap-2 text-zinc-300">
                  <input
                    type="checkbox"
                    checked={editingTestimonial.featured}
                    onChange={(e) => setEditingTestimonial({...editingTestimonial, featured: e.target.checked})}
                    className="rounded"
                  />
                  Destacado
                </label>
              </div>
              <div className="flex gap-3 pt-4">
                <Button type="button" variant="outline" onClick={() => setEditingTestimonial(null)} className="flex-1 rounded-xl border-zinc-700 text-zinc-300">
                  Cancelar
                </Button>
                <Button type="submit" className="flex-1 bg-pink-600 hover:bg-pink-700 text-white rounded-xl">
                  Guardar
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

// Componente de Descuentos
const DiscountsPanel = () => {
  const [discounts, setDiscounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [challenges, setChallenges] = useState([]);
  const [newDiscount, setNewDiscount] = useState({
    code: '',
    discount_type: 'percentage',
    discount_value: 10,
    applicable_to: 'all',
    specific_challenges: [],
    max_uses: 0,
    expires_at: '',
    is_active: true
  });
  const token = localStorage.getItem('session_token');

  useEffect(() => {
    fetchDiscounts();
    fetchChallenges();
    createDefaultDiscount();
  }, []);

  const fetchChallenges = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/content?category=challenge`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setChallenges(response.data || []);
    } catch (error) {
      console.error('Error fetching challenges:', error);
    }
  };

  const createDefaultDiscount = async () => {
    // Crear BIENVENIDA10 si no existe
    try {
      await axios.post(`${BACKEND_URL}/api/admin/discounts`, {
        code: 'BIENVENIDA10',
        discount_type: 'percentage',
        discount_value: 10,
        applicable_to: 'all',
        max_uses: 0,
        is_active: true
      }, { headers: { Authorization: `Bearer ${token}` } });
    } catch (e) {
      // Ya existe, ignorar
    }
  };

  const fetchDiscounts = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/admin/discounts`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setDiscounts(response.data || []);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const createDiscount = async (e) => {
    e.preventDefault();
    if (!newDiscount.code || newDiscount.discount_value <= 0) {
      toast.error('Código y valor son requeridos');
      return;
    }

    try {
      const payload = {
        ...newDiscount,
        specific_products: newDiscount.applicable_to === 'specific_challenges' ? newDiscount.specific_challenges : []
      };
      await axios.post(`${BACKEND_URL}/api/admin/discounts`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Descuento creado');
      setShowCreateModal(false);
      setNewDiscount({ code: '', discount_type: 'percentage', discount_value: 10, applicable_to: 'all', specific_challenges: [], max_uses: 0, expires_at: '', is_active: true });
      fetchDiscounts();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al crear');
    }
  };

  const toggleActive = async (discount) => {
    try {
      await axios.put(`${BACKEND_URL}/api/admin/discounts/${discount.discount_id}`, {
        is_active: !discount.is_active
      }, { headers: { Authorization: `Bearer ${token}` } });
      fetchDiscounts();
    } catch (error) {
      toast.error('Error al actualizar');
    }
  };

  const deleteDiscount = async (discountId) => {
    if (!window.confirm('¿Eliminar este descuento?')) return;
    try {
      await axios.delete(`${BACKEND_URL}/api/admin/discounts/${discountId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Descuento eliminado');
      fetchDiscounts();
    } catch (error) {
      toast.error('Error al eliminar');
    }
  };

  const applicableLabels = {
    'all': 'Todos los productos',
    'nivel_1': 'Solo Nivel 1',
    'nivel_2': 'Solo Nivel 2',
    'premium': 'Solo Premium',
    'specific_challenges': 'Challenges específicos'
  };

  const getApplicableLabel = (disc) => {
    if (disc.applicable_to === 'specific_challenges' || (disc.specific_products && disc.specific_products.length > 0)) {
      const challengeCount = disc.specific_products?.length || 0;
      return `${challengeCount} challenge${challengeCount !== 1 ? 's' : ''} específico${challengeCount !== 1 ? 's' : ''}`;
    }
    return applicableLabels[disc.applicable_to] || disc.applicable_to;
  };

  if (loading) return <div className="text-center py-8">Cargando descuentos...</div>;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold flex items-center gap-2">
          <Percent className="w-6 h-6 text-pink-500" />
          Códigos de Descuento
        </h2>
        <Button 
          onClick={() => setShowCreateModal(true)}
          className="bg-pink-600 hover:bg-pink-700 text-white rounded-full"
        >
          + Crear Descuento
        </Button>
      </div>

      {/* Estadísticas */}
      <div className="grid grid-cols-3 gap-4">
        <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800 text-center">
          <p className="text-3xl font-bold text-pink-500">{discounts.length}</p>
          <p className="text-sm text-zinc-500">Total Códigos</p>
        </div>
        <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800 text-center">
          <p className="text-3xl font-bold text-green-500">
            {discounts.filter(d => d.is_active).length}
          </p>
          <p className="text-sm text-zinc-500">Activos</p>
        </div>
        <div className="bg-zinc-900 rounded-2xl p-4 border border-zinc-800 text-center">
          <p className="text-3xl font-bold text-blue-500">
            {discounts.reduce((acc, d) => acc + (d.times_used || 0), 0)}
          </p>
          <p className="text-sm text-zinc-500">Usos Totales</p>
        </div>
      </div>

      {/* Lista de descuentos */}
      <div className="bg-zinc-900 rounded-2xl border border-zinc-800 overflow-hidden">
        <table className="w-full">
          <thead className="bg-zinc-800">
            <tr>
              <th className="text-left p-4 font-medium">Código</th>
              <th className="text-left p-4 font-medium">Descuento</th>
              <th className="text-left p-4 font-medium">Aplica a</th>
              <th className="text-left p-4 font-medium">Usos</th>
              <th className="text-left p-4 font-medium">Estado</th>
              <th className="text-center p-4 font-medium">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {discounts.length === 0 ? (
              <tr>
                <td colSpan={6} className="text-center py-8 text-zinc-500">
                  No hay códigos de descuento
                </td>
              </tr>
            ) : (
              discounts.map(disc => (
                <tr key={disc.discount_id} className="border-t hover:bg-zinc-800">
                  <td className="p-4">
                    <span className="font-mono font-bold text-pink-600 bg-pink-50 px-3 py-1 rounded-lg">
                      {disc.code}
                    </span>
                  </td>
                  <td className="p-4">
                    <span className="font-bold">
                      {disc.discount_value}{disc.discount_type === 'percentage' ? '%' : ' USD'}
                    </span>
                  </td>
                  <td className="p-4 text-sm text-zinc-500">
                    {getApplicableLabel(disc)}
                  </td>
                  <td className="p-4">
                    <span className="text-sm">
                      {disc.times_used || 0} {disc.max_uses > 0 ? `/ ${disc.max_uses}` : '(ilimitado)'}
                    </span>
                  </td>
                  <td className="p-4">
                    <button
                      onClick={() => toggleActive(disc)}
                      className={`px-3 py-1 rounded-full text-xs font-medium transition-colors ${
                        disc.is_active 
                          ? 'bg-green-100 text-green-700 hover:bg-green-200' 
                          : 'bg-red-100 text-red-700 hover:bg-red-200'
                      }`}
                    >
                      {disc.is_active ? '✓ Activo' : '✗ Inactivo'}
                    </button>
                  </td>
                  <td className="p-4 text-center">
                    <button
                      onClick={() => deleteDiscount(disc.discount_id)}
                      className="text-red-500 hover:text-red-700 p-2"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Modal crear descuento */}
      {showCreateModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-zinc-900 rounded-2xl p-6 w-full max-w-md">
            <h3 className="text-xl font-bold mb-4">Crear Código de Descuento</h3>
            <form onSubmit={createDiscount} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1 text-zinc-300">Código</label>
                <input
                  value={newDiscount.code}
                  onChange={(e) => setNewDiscount({...newDiscount, code: e.target.value.toUpperCase()})}
                  placeholder="DESCUENTO20"
                  className="w-full px-4 py-2 border border-zinc-700 rounded-xl uppercase bg-zinc-800 text-white placeholder:text-zinc-500"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-1 text-zinc-300">Tipo</label>
                  <select
                    value={newDiscount.discount_type}
                    onChange={(e) => setNewDiscount({...newDiscount, discount_type: e.target.value})}
                    className="w-full px-4 py-2 border border-zinc-700 rounded-xl bg-zinc-800 text-white"
                  >
                    <option value="percentage">Porcentaje (%)</option>
                    <option value="fixed">Monto Fijo (USD)</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-zinc-300">Valor</label>
                  <input
                    type="number"
                    value={newDiscount.discount_value}
                    onChange={(e) => setNewDiscount({...newDiscount, discount_value: parseFloat(e.target.value) || 0})}
                    min="0.01"
                    step="0.01"
                    className="w-full px-4 py-2 border border-zinc-700 rounded-xl bg-zinc-800 text-white placeholder:text-zinc-500"
                    placeholder="Ej: 8.5"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1 text-zinc-300">Aplica a</label>
                <select
                  value={newDiscount.applicable_to}
                  onChange={(e) => setNewDiscount({...newDiscount, applicable_to: e.target.value, specific_challenges: []})}
                  className="w-full px-4 py-2 border border-zinc-700 rounded-xl bg-zinc-800 text-white"
                >
                  <option value="all">Todos los productos</option>
                  <option value="nivel_1">Solo Nivel 1</option>
                  <option value="nivel_2">Solo Nivel 2</option>
                  <option value="premium">Solo Premium</option>
                  <option value="specific_challenges">Challenges específicos</option>
                </select>
              </div>
              
              {/* Selector de Challenges Específicos */}
              {newDiscount.applicable_to === 'specific_challenges' && (
                <div>
                  <label className="block text-sm font-medium mb-1 text-zinc-300">Seleccionar Challenges</label>
                  <div className="border border-zinc-700 rounded-xl p-3 max-h-48 overflow-y-auto space-y-2 bg-zinc-800">
                    {challenges.length === 0 ? (
                      <p className="text-sm text-zinc-500">No hay challenges disponibles</p>
                    ) : (
                      challenges.map(ch => (
                        <label key={ch.content_id} className="flex items-center gap-2 cursor-pointer hover:bg-zinc-700 p-2 rounded-lg text-white">
                          <input
                            type="checkbox"
                            checked={newDiscount.specific_challenges.includes(ch.content_id)}
                            onChange={(e) => {
                              const updated = e.target.checked
                                ? [...newDiscount.specific_challenges, ch.content_id]
                                : newDiscount.specific_challenges.filter(id => id !== ch.content_id);
                              setNewDiscount({...newDiscount, specific_challenges: updated});
                            }}
                            className="w-4 h-4 text-pink-600 rounded"
                          />
                          <span className="text-sm">{ch.title}</span>
                          {ch.price && <span className="text-xs text-zinc-500">(${ch.price})</span>}
                        </label>
                      ))
                    )}
                  </div>
                  {newDiscount.specific_challenges.length > 0 && (
                    <p className="text-xs text-pink-500 mt-1">
                      {newDiscount.specific_challenges.length} challenge(s) seleccionado(s)
                    </p>
                  )}
                </div>
              )}
              <div>
                <label className="block text-sm font-medium mb-1 text-zinc-300">Usos Máximos (0 = ilimitado)</label>
                <input
                  type="number"
                  value={newDiscount.max_uses}
                  onChange={(e) => setNewDiscount({...newDiscount, max_uses: Number(e.target.value)})}
                  min="0"
                  className="w-full px-4 py-2 border border-zinc-700 rounded-xl bg-zinc-800 text-white"
                />
              </div>
              <div className="flex gap-3 pt-4">
                <Button type="button" onClick={() => setShowCreateModal(false)} className="flex-1 bg-zinc-700 hover:bg-zinc-600 text-white rounded-full">
                  Cancelar
                </Button>
                <Button type="submit" className="flex-1 bg-pink-600 hover:bg-pink-700 text-white rounded-full">
                  Crear Descuento
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

// Componente principal del Admin Dashboard
const AdminDashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeSection, setActiveSection] = useState('dashboard');
  const [stats, setStats] = useState({});
  const navigate = useNavigate();

  const token = localStorage.getItem('session_token');

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/admin/stats`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  useEffect(() => {
    fetchStats();
    
    // Escuchar eventos de navegación
    const handleNavigate = (e) => setActiveSection(e.detail);
    window.addEventListener('admin-navigate', handleNavigate);
    return () => window.removeEventListener('admin-navigate', handleNavigate);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('session_token');
    navigate('/login');
    toast.success('Sesión cerrada');
  };

  const menuItems = [
    { id: 'dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { id: 'challenges', icon: Trophy, label: 'Challenges' },
    { id: 'testimonials', icon: Star, label: 'Testimonios' },
    { id: 'content-manager', icon: FolderOpen, label: 'Gestor de Contenido' },
    { id: 'programs', icon: Package, label: 'Programas' },
    { id: 'subscription-pricing', icon: Tag, label: 'Precios por Periodo', link: '/admin/subscription-pricing' },
    { id: 'club-vip', icon: Crown, label: 'Club VIP', link: '/admin/club-vip' },
    { id: 'library-exercises', icon: Dumbbell, label: 'Biblioteca de Ejercicios', link: '/admin/library-exercises' },
    { id: 'training-techniques', icon: Sparkles, label: 'Técnicas de Entrenamiento', link: '/admin/training-techniques' },
    { id: 'user-routines', icon: ClipboardList, label: 'Rutinas de Usuarios', link: '/admin/user-routines' },
    { id: 'discounts', icon: Percent, label: 'Descuentos' },
    { id: 'users-subscribers', icon: Users, label: 'Usuarios y Suscriptores' },
    { id: 'notifications', icon: Bell, label: 'Notificaciones' },
    { id: 'income', icon: DollarSign, label: 'Ingresos', link: '/admin/income' },
    { id: 'content-stats', icon: BarChart3, label: 'Estadísticas Contenido', link: '/admin/content-stats' },
    { id: 'admin-users', icon: Shield, label: 'Administradores', link: '/admin/users' },
    { id: 'site-config', icon: Settings, label: 'Configuración Sitio' },
    { id: 'test-accounts', icon: UserPlus, label: 'Cuentas de Prueba' },
  ];

  const renderContent = () => {
    switch (activeSection) {
      case 'dashboard':
        return <DashboardStats stats={stats} />;
      case 'programs':
        return <AdminPrograms />;
      case 'content-manager':
        return <AdminContentManager embedded />;
      case 'content':
        return <AdminContent embedded />;
      case 'notifications':
        return <NotificationsPanel />;
      case 'users-subscribers':
        return <UsersAndSubscribersPanel />;
      case 'discounts':
        return <DiscountsPanel />;
      case 'testimonials':
        return <TestimonialsPanel />;
      case 'nutrition-forms':
        return <NutritionFormsPanel />;
      case 'challenges':
        return <ChallengesPanel />;
      case 'test-accounts':
        return <TestAccountsPanel />;
      case 'site-config':
        return <AdminSiteConfig embedded />;
      default:
        return <DashboardStats stats={stats} />;
    }
  };

  return (
    <div className="min-h-screen bg-[#09090b] flex">
      {/* Sidebar */}
      <aside className={`${sidebarOpen ? 'w-64' : 'w-20'} bg-zinc-900 text-white transition-all duration-300 flex flex-col fixed h-full z-50`}>
        <div className="p-4 border-b border-zinc-800">
          <div className="flex items-center justify-between">
            {sidebarOpen && (
              <h1 className="text-lg font-bold text-pink-400">Admin Panel</h1>
            )}
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="p-2 hover:bg-zinc-800 rounded-lg"
            >
              {sidebarOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => {
                if (item.link) {
                  navigate(item.link);
                } else {
                  setActiveSection(item.id);
                }
              }}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                activeSection === item.id
                  ? 'bg-pink-600 text-white'
                  : 'text-zinc-400 hover:bg-zinc-800 hover:text-white'
              }`}
            >
              <item.icon className="w-5 h-5 flex-shrink-0" />
              {sidebarOpen && <span>{item.label}</span>}
            </button>
          ))}
        </nav>

        <div className="p-4 border-t border-zinc-800">
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-zinc-400 hover:bg-zinc-800 hover:text-white transition-all"
          >
            <LogOut className="w-5 h-5 flex-shrink-0" />
            {sidebarOpen && <span>Cerrar Sesión</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className={`flex-1 ${sidebarOpen ? 'ml-64' : 'ml-20'} transition-all duration-300`}>
        <header className="bg-zinc-900 border border-zinc-800 px-6 py-4 sticky top-0 z-40">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-xl font-bold">
                {menuItems.find(m => m.id === activeSection)?.label || 'Dashboard'}
              </h1>
              <p className="text-sm text-zinc-500">Booty & Legs Academy - Panel de Administración</p>
            </div>
            <div className="flex items-center gap-4">
              <a 
                href="/" 
                target="_blank" 
                className="flex items-center gap-2 text-zinc-400 hover:text-pink-600"
              >
                <Eye className="w-4 h-4" />
                Ver sitio web
              </a>
            </div>
          </div>
        </header>

        <div className="p-6">
          {renderContent()}
        </div>
      </main>
    </div>
  );
};

export default AdminDashboard;
